import type IEndPoint from 'interfaces/EndPointTypes';
import { AuthProtect } from '@/common/enum';

export const sendSupportMsg = (data: ContactFormData): IEndPoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'POST',
    url: 'api/contact-support',
    data,
  };
};
